import { render, staticRenderFns } from "./admin-menu.vue?vue&type=template&id=7011999e&scoped=true"
import script from "./admin-menu.vue?vue&type=script&lang=js"
export * from "./admin-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7011999e",
  null
  
)

export default component.exports